import template from './p360SharedView.html';

export function p360SharedViewDirective() {
  'ngInject';

  return {
    restrict: 'E',
    template: template,
    controller: p360SharedViewController,
    controllerAs: 'p360SharedView',
    bindToController: true
  };
}

class p360SharedViewController {
  constructor($routeParams, $scope, $interval, Clients, DownloadFile, Notes, ConnectionQuality, $rootScope) {
    'ngInject';

    this.$scope = $scope;
    this.$rootScope = $rootScope;
    this.shareId = $routeParams.id;
    this.expired = false;
    this.selectedProcessGroup = '';
    this.worklogState = {sort: {}, search: {}, pagination: {start: 0, totalItemCount: 0}};
    this.worklogPageSize = '10';
    this.worklogCurrentPage = 0;
    this.showVaProcesses = true;
    this.showWorklogs = false;
    this.exportWorklogs = false;
    this.Clients = Clients;
    this.DownloadFile = DownloadFile;
    this.Notes = Notes;
    this.ConnectionQuality = ConnectionQuality;
    this.fetchSharedChartData(1);
    this.name = null;
    this.currentCurrency = null;

    this.timeout = $interval(() => {
      this.notes = Notes.getNotes();
    }, 10);

    $scope.$on("$destroy", () => {
      $interval.cancel( this.timeout );
    });

    $scope.$on('connectionQualityChanged', () => {
      if (this.ConnectionQuality.isSlow) {
        this.Notes.postNote({
          type: 'slowConnection',
          manualHide: true
        });
      }
      else {
        const note = this.Notes.getNotes().find(note => note.type === 'slowConnection' && note.active);
        if (note)
          this.Notes.hide(note);
      }
    });
  }

  callServer(state) {
    if (JSON.stringify(state) !== JSON.stringify(this.$parent.p360SharedView.worklogState)) {
      this.$parent.p360SharedView.worklogState = state;
      this.$parent.p360SharedView.fetchSharedChartData(1);
    }
  }

  downloadExcel() {
    this.state = "loading";
    this.Clients.getWorklogsExportedData(this.shareId)
      .then(res => {
        this.DownloadFile.downloadFromResponse(
          res,
          res.headers('content-type'),
          `klix-360-worklogs.xlsx`
          );
        this.state = "loaded";
      }, () => {
        this.state = "error";
      });
  }

  fetchSharedChartData(currentPage) {
    if (!this.shareId) {
      return;
    }

    this.state = "loading";
    const sort = this.worklogState.sort ? this.worklogState.sort.predicate : null;
    const direction = this.worklogState.sort ? this.worklogState.sort.reverse : null;
    this.Clients.getSharedData(this.shareId, this.worklogPageSize, this.worklogsOffset, sort, direction)
      .then(res => {
        this.name = res.data.shareName;
        this.setupCharts(res.data.data);
        this.showWorklogs = res.data.includeWorklogs;
        this.exportWorklogs = this.showWorklogs && res.data.allowExport;
        this.data.summaries = res.data.data.chartData.summaries;
        this.currentCurrency = res.data.data.currency;
        this.currencyRatio = res.data.data.currencyRatio;
        if (this.showWorklogs) {
          this.worklogCurrentPage = currentPage ? currentPage : 1;
          this.setupWorklogTable(res.data.worklogs);
        }

        this.expired = false;
        this.state = "loaded";
      }, error => {
        this.expired = error.status === 400;
        this.state = "error";
      });
  }

  pageChange(newPage) {
    if (newPage < 1 || newPage > this.worklogsPagesCount) {
      return;
    }

    this.worklogCurrentPage = newPage < 1 ? 1 :
      newPage > this.worklogsPagesCount ? this.worklogsPagesCount : newPage;
    this.worklogsOffset = (this.worklogCurrentPage - 1) * parseInt(this.worklogPageSize);
    this.fetchSharedChartData(this.worklogCurrentPage, this.worklogsOffset);
  }

  pageSizeChange() {
    this.worklogCurrentPage = 1;
    this.worklogsOffset = 0;
    this.fetchSharedChartData(this.worklogCurrentPage, this.worklogsOffset);
  }

  processGroupChanged(processGroup) {
    this.selectedProcessGroup = processGroup;
    this.$scope.$apply();
  }

  setupCharts(data) {
    if(data !== undefined && data.chartData.showZero !== undefined) {
      this.$rootScope.dataVolSlicerChartshowZero = data.chartData.showZero;
    }

    if(data === undefined) return;

    this.currency = data.currency;
    this.currencyRatio = data.currencyRatio;
    if (data.type === 'all') {
      this.data = data.chartData;
      return;
    }

    this.data = {
      vaAddedProcesses: data.type === 'va_processes' ? data.chartData : null,
      nvaAddedProcesses: data.type === 'nva_processes' ? data.chartData : null,
      effectiveRates: data.type === 'prof_and_hour_rate' ? data.chartData : null,
      valueAddedByMonth: data.type === 'va_and_nva' ? data.chartData : null,
      processGroup: data.type === 'process_group' ? data.chartData : null,
      processProblems: data.type === 'process_problems' ? data.chartData : null,
      timeBySeniorityLevel: data.type === 'employee_role' ? data.chartData : null,
      volumesHours: data.type === 'vol_slicer_hours' ? data.chartData : null,
      volumesValues: data.type === 'vol_slicer_volume' ? data.chartData : null,
    };

    if (data.type === 'vol_slicer_table') {
      this.data.volumes = data.chartData.volumes;
      this.data.vaAddedProcesses = data.chartData.vaAddedProcesses;
      this.showVaProcesses = false;
    }

    if (data.type === 'process_problems') {
      this.$rootScope.processProblemsShared = data.processProblems;
    }

    if (data.type === 'employee_role') {
      this.$rootScope.seniorityLevelShared = data.seniorityLevel;
    }
  }

  setupWorklogTable(worklogs) {
    this.worklogs = worklogs.data;
    this.worklogsTotal = worklogs.total;
    this.worklogsPagesCount = Math.ceil(worklogs.total / parseInt(this.worklogPageSize));
    const startPage = this.worklogCurrentPage - 1 < 2 ? 2 :
      this.worklogCurrentPage > this.worklogsPagesCount - 3 ?
        this.worklogsPagesCount - 3 : this.worklogCurrentPage - 1;
    let worklogPages = [];
    let counter = startPage;
    while (startPage + 3 > counter) {
      worklogPages.push(counter);
      counter++;
    }

    worklogPages = worklogPages.filter(x => x < this.worklogsPagesCount && x > 0);
    this.worklogPages = worklogPages;

    if (this.worklogsPagesCount && this.worklogPages[0] !== 1) {
      this.worklogPages.unshift(1);
    }

    if (this.worklogsPagesCount > 1 && this.worklogPages[this.worklogPages.length - 1] !== this.worklogsPagesCount) {
      this.worklogPages.push(this.worklogsPagesCount);
    }
  }
}
